const UPDATES = [
  { date: '2024-07-28', title: '《我独自升级》外传正式确认连载，讲述暗影君主之后的番外故事', tag: '新作' },
  { date: '2024-07-27', title: 'Naver Webtoon公布2024下半年新作阵容，多部奇幻题材引期待', tag: '资讯' },
  { date: '2024-07-26', title: '《全知读者视角》动画PV首曝，制作阵容豪华引全球粉丝狂欢', tag: '动画' },
  { date: '2024-07-25', title: '韩国漫画平台Kakao Page用户突破5000万，全球扩张加速', tag: '行业' },
  { date: '2024-07-24', title: '多部韩国漫画改编韩剧定档下半年，原作漫画热度再创新高', tag: '影视' },
  { date: '2024-07-23', title: '韩国漫画振兴院发布2024上半年漫画产业报告，市场规模持续增长', tag: '行业' },
  { date: '2024-07-22', title: '《神之塔》第二季确认制作，作者SIU亲自参与脚本创作', tag: '续作' },
  { date: '2024-07-21', title: '新人漫画家作品《暗夜追光》上线首周即破百万阅读', tag: '新作' },
  { date: '2024-07-20', title: '本站新增15个优质韩国漫画网站收录，已更新至韩国漫画网站大全', tag: '站点' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          最新动态
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          韩国漫画行业资讯与本站更新信息，每日同步最新内容
        </p>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {UPDATES.map((item, i) => (
              <div
                key={i}
                className="relative mb-6 last:mb-0"
              >
                <div className="absolute -left-[25px] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 top-1.5"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mb-1">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                    item.tag === '新作' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '动画' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '续作' ? 'bg-secondary-100 text-secondary-700' :
                    'bg-background-200 text-foreground-600'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <p className="text-foreground-700 text-sm leading-relaxed">
                  {item.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}